import React from 'react';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { ITableProps } from './Table';
import { DataCard } from './DataCard';

export interface IDataCardsProps<T extends Object> extends ITableProps<T> {}

export function DataCards<T extends Object>({
  className,
  data,
  columns,
  ...otherProps
}: IDataCardsProps<T>): React.ReactElement {
  const bem = useBemCN('data-cards');

  return (
    <div {...bem(null, null, className)}>
      {data.map(item => (
        <DataCard
          key={item['email']}
          {...bem('item')}
          data={item}
          // FIXME: unsafe casting - Header could be a function
          // FIXME: unsafe casting - accessor
          columns={
            columns as {
              Header: string;
              accessor: Extract<keyof T, string>;
            }[]
          }
          {...otherProps}
        />
      ))}
    </div>
  );
}
